<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Devolución Pedido'"
      />
      <div
        class="form-box-body"
        style="height: 320px !important"
      >
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />

            <div
              class="form_label"
              v-text="'Ingresa tu Nombre y Apellido *'"
            />
            <div class="form__field">
              <label
                for="nombre"
              ><v-icon
                name="user"
                scale="1"
                style="margin: 1px 1px 0"
              /></label>
              <input
                id="nombre"
                ref="nombre"
                v-model="nombre"
                autocomplete="off"
                type="text"
                name="nombre"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keyup.enter="focusTo('rut')"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('nombre', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'RUT *'"
            />
            <div class="form__field">
              <label
                for="rut"
              ><v-icon
                name="address-card"
                scale="1"
                style="margin-top: 3px"
              /></label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="XX.XXX.XXX-X"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('telefono')"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>

            <div
              class="form_label"
              v-text="'Teléfono de contacto *'"
            />
            <div class="form__field">
              <label
                for="telefono"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 1px 2px 0 4px"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('email')"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Ingresa tu email *'"
            />
            <div class="form__field">
              <label
                for="email"
              ><v-icon
                name="envelope"
                scale="1"
                style="margin-top: 2px"
              /></label>
              <input
                id="email"
                ref="email"
                v-model="email"
                class="email"
                autocomplete="off"
                type="text"
                name="email"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('boleta')"
                @keypress="keyPressCheckSpecialChars($event, 'email')"
                @change="cleanSpecialChars('email', 'email')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Boleta *'"
            />
            <div class="form__field">
              <label
                for="boleta"
              ><v-icon
                name="file"
                scale="1"
                style="margin: 1px 2px 0 4px"
              /></label>
              <input
                id="boleta"
                ref="boleta"
                v-model="boleta"
                autocomplete="off"
                type="text"
                name="boleta"
                value=""
                placeholder="N° Boleta"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('boleta', 'phone')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Pago'"
            />
            <select
              id="form_estilos"
              v-model="pago"
              :multiple="false"
              class="formulario_combo"
              @change="_seleccionPago($event.target.value)"
            >
              <option value>
                Seleccione Pago
              </option>
              <option value="Crédito">
                Crédito
              </option>
              <option value="Débito">
                Débito
              </option>
            </select>

            <template v-if="pago === 'Débito'">
              <div
                class="form_label"
                v-text="'Número de cuenta *'"
              />
              <div class="form__field">
                <label
                  for="numero_cuenta"
                ><v-icon
                  name="address-card"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                /></label>
                <input
                  id="numero_cuenta"
                  ref="numero_cuenta"
                  v-model="numero_cuenta"
                  autocomplete="off"
                  type="text"
                  name="numero_cuenta"
                  value=""
                  placeholder="12345678"
                  required
                  @focus="_clearError"
                  @keyup.enter="focusTo('numero_cuenta')"
                  @keypress="keyPressCheckSpecialChars($event, 'phone')"
                  @change="cleanSpecialChars('numero_cuenta', 'phone')"
                >
              </div>

              <div
                class="form_label"
                v-text="'Tipo de cuenta'"
              />
              <select
                id="form_estilos"
                v-model="tipo_cuenta"
                :multiple="false"
                class="formulario_combo"
                @change="_seleccionTipoCuenta($event.target.value)"
              >
                <option value>
                  Seleccione tipo de cuenta
                </option>
                <option value="Corriente">
                  Corriente
                </option>
                <option value="Vista">
                  Vista
                </option>
              </select>

              <div
                class="form_label"
                v-text="'Banco *'"
              />
              <div class="form__field">
                <label
                  for="banco"
                ><v-icon
                  name="file"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                /></label>
                <input
                  id="banco"
                  ref="banco"
                  v-model="banco"
                  autocomplete="off"
                  type="text"
                  name="banco"
                  value=""
                  placeholder="Banco Estado"
                  required
                  @focus="_clearError"
                  @keyup.enter="focusTo('banco')"
                  @keypress="keyPressCheckSpecialChars($event, 'name')"
                  @change="cleanSpecialChars('banco', 'name')"
                >
              </div>
            </template>

            <div
              class="form_label"
              v-text="'Devolución *'"
            />
            <form class="formulario-check">
              <label class="form-check">
                <input
                  v-model="devolucionTienda"
                  type="checkbox"
                  value
                  @change="checkReturnTienda($event)"
                >
                <p class="tua_checkbox">Tienda</p>
              </label>
            </form>
            <form class="formulario-check">
              <label class="form-check">
                <input
                  v-model="devolucionCourier"
                  type="checkbox"
                  value
                  @change="checkReturnCourier($event)"
                >
                <p class="tua_checkbox">Courier</p>
              </label>
            </form>

            <div
              class="form_label"
              style="padding-top: 15px"
              v-text="'Comuna'"
            />
            <cool-select
              v-model="communeSelected"
              :items="communes"
              :placeholder="communeSelected ? communeSelected.name : 'Comuna'"
              item-text="name"
              @select="_seleccionComuna(communeSelected)"
            >
              <template
                slot="item"
                slot-scope="{ item: itemCommune }"
                class="listado-container"
              >
                <label class="chip-cuenta selected">
                  <div class="itemtest">
                    <div class="item_date_cliente">
                      {{ itemCommune.name }}
                      <br>
                    </div>
                  </div>
                </label>
              </template>

              <template
                slot="selection"
                slot-scope="{ item: communeSelected }"
              >
                <div class="item_date_cliente">
                  <b>Nombre:</b>
                  {{ communeSelected.name }}
                </div>
              </template>
              <template slot="no-data">
                No existen datos
              </template>
            </cool-select>

            <div
              class="form_label"
              v-text="'Sucursal'"
            />
            <select
              id="form_estilos"
              v-model="sucursal"
              :multiple="false"
              class="formulario_combo"
              @change="_seleccionSucursal($event.target.value)"
            >
              <option value>
                Seleccione Sucursal
              </option>
              <option
                v-for="option in sucursales"
                :key="option._id"
              >
                {{ option.code_name }}
              </option>
            </select>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/credit-card'
import 'vue-awesome/icons/dollar-sign'
import 'vue-awesome/icons/mobile-alt'
import 'vue-awesome/icons/exchange-alt'
import 'vue-awesome/icons/address-card'
import 'vue-awesome/icons/file'
import utils from './utils'
import { CoolSelect } from 'vue-cool-select'

export default {
  components: {
    'v-icon': Icon,
    CoolSelect
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      comentario: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      nombre: '',
      email: '',
      telefono: '',
      rut: '',
      boleta: '',
      devolucion: '',
      devolucionTienda: false,
      devolucionCourier: false,
      communes: [],
      communeSelected: '',
      sucursales: [],
      sucursalSelected: '',
      sucursal: '',
      pago: '',
      numero_cuenta: '',
      tipo_cuenta: '',
      banco: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'TUADevolucionPedidosForm') return
      // if (e.evento === "init") {}
      if (e.evento === 'newdata') {
        // this.title = e.dato.title ? e.dato.title : "TUA Devolución Pedido";
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.communes = e.dato.fields.communes ? e.dato.fields.communes : []
        this.numero_cuenta = e.dato.fields.numero_cuenta
          ? e.dato.numero_cuenta
          : ''
        this.tipo_cuenta = e.dato.fields.tipo_cuenta ? e.dato.tipo_cuenta : ''
        this.banco = e.dato.fields.banco ? e.dato.banco : ''

        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
      }
    })
  },
  methods: {
    _seleccionPago () {
      this.errormsg = ''
    },
    _seleccionTipoCuenta () {
      this.errormsg = ''
    },
    _seleccionBanco () {
      this.errormsg = ''
    },
    _seleccionComuna (val) {
      this.errormsg = ''
      this.sucursales = []
      this.sucursal = ''
      for (const i in this.communes) {
        const commune = this.communes[i]
        if (commune.name === val.name) {
          for (const x in commune.branches) {
            const branch = commune.branches[x]
            this.sucursales.push(branch)
          }
        }
      }
    },
    _seleccionSucursal (val) {
      this.errormsg = ''
      for (const i in this.sucursales) {
        const sucursal = this.sucursales[i]
        if (sucursal.code_name === val) {
          this.sucursalSelected = sucursal
        }
      }
    },
    _formatearRut (val) {
      this.rut = utils.cleanSpecialChars(val, 'rut')
      this.rut = utils.formatearRut(this.rut)
    },
    _clearError () {
      this.errormsg = ''
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    checkReturnCourier () {
      if (this.devolucionCourier) {
        this.devolucionTienda = false
      }
    },
    checkReturnTienda () {
      if (this.devolucionTienda) {
        this.devolucionCourier = false
      }
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre) {
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (this.rut === '') {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar tu rut'
        return
      }
      if (!utils.validaRut(this.rut)) {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingregar RUT válido'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar teléfono'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.boleta) {
        this.errormsg = 'Debes ingresar N° Boleta'
        return
      }
      if (!this.pago) {
        this.errormsg = 'Debes seleccionar pago'
        return
      }
      if (this.pago === 'Débito') {
        if (!this.numero_cuenta) {
          this.errormsg = 'Debes ingresar numero de cuenta'
          return
        }
        if (!this.tipo_cuenta) {
          this.errormsg = 'Debes seleccionar tipo de cuenta'
          return
        }
        if (!this.banco) {
          this.errormsg = 'Debes ingresar banco'
          return
        }
      }
      if (!this.devolucionCourier && !this.devolucionTienda) {
        this.errormsg = 'Debes ingresar devolución'
        return
      }
      this.devolucion = this.devolucionCourier ? 'Courier' : 'Tienda'

      if (!this.communeSelected) {
        this.errormsg = 'Debes seleccionar una comuna'
        return
      }
      if (!this.sucursal) {
        this.errormsg = 'Debes seleccionar una sucursal'
        return
      }
      // Datos form
      let dataToSend = {
        form: 'TUADevolucionPedidosForm',
        evento: 'sentClick',
        data: {
          fields: {
            firstname: this.nombre,
            rut: this.rut,
            phone: this.telefono,
            email: this.email,
            boleta: this.boleta,
            pago: this.pago,
            devolucion: this.devolucion,
            comuna: this.communeSelected.name,
            sucursal: this.sucursalSelected.code_name,
            infosucursal: this.sucursalSelected
          }
        }
      }
      if (this.pago === 'Débito') {
        dataToSend = {
          form: 'TUADevolucionPedidosForm',
          evento: 'sentClick',
          data: {
            fields: {
              ...dataToSend.data.fields,
              numero_cuenta: this.numero_cuenta,
              tipo_cuenta: this.tipo_cuenta,
              banco: this.banco
            }
          }
        }
      }

      dataToSend.data.type = 'tua-devolucion-pedidos-confirm'
      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'TUADevolucionPedidosForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
  height: 335px;
}

.tua_checkbox {
 margin: 13px 0 0 8px;
}

.form-check {
      width: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.formulario-check {
    margin-left: 10%;
}
</style>

<style>
.IZ-select .IZ-select__menu {
  width: 270px !important;
}

.IZ-select__menu-items {
  margin: -3% 0 3% 8%;
  max-height: none !important;
}

.IZ-select__input-wrap {
  font-size: 20px;
}

.IZ-select .IZ-select__input-wrap .IZ-select__input input {
  background: url(../src/assets/arrow_select.png) no-repeat 97% center #ecefef;
  width: 220px !important;
  height: 35px !important;
  background-color: #ecefef;
  margin: 0 0 0 20px !important;
  border: 0;
  height: 35px;
  -webkit-box-flex: 0;
  -ms-flex: none;
  flex: none;
  -webkit-appearance: button;
  border-radius: 25px;
  padding: 0 5%;
  background-size: 10%;
  cursor: pointer;
  outline: none;
  margin: 5px 0 15px 20px !important;
  font-size: 13px !important;
}

.IZ-select__input {
  width: 100% !important;
}

.IZ-select {
  outline: none;
  box-sizing: content-box !important;
}
</style>
